var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonation4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.421,
    height: 32,
    viewBox: "0 0 40.421 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subscriptions",
    transform: "translate(0 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M26.421,37.368H19.684a1.684,1.684,0,1,1,0-3.368h6.737a1.684,1.684,0,1,1,0,3.368Z",
    transform: "translate(-2.842 -4.579)",
    fill: "none",
    stroke: "#b07f4a",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    d: "M15.789,21.842A.842.842,0,1,1,14.947,21,.842.842,0,0,1,15.789,21.842Zm0,3.368a.842.842,0,1,1-.842-.842A.842.842,0,0,1,15.789,25.211Zm0,3.368a.842.842,0,1,1-.842-.842A.842.842,0,0,1,15.789,28.579ZM5.684,24.368a.842.842,0,1,1-.842-.842A.842.842,0,0,1,5.684,24.368Zm0,3.368a.842.842,0,1,1-.842-.842A.842.842,0,0,1,5.684,27.737Zm0,3.368a.842.842,0,1,1-.842-.842A.842.842,0,0,1,5.684,31.105Zm21.053-8.421H18.316a.842.842,0,0,1,0-1.684h8.421a.842.842,0,1,1,0,1.684Zm0,3.368H18.316a.842.842,0,0,1,0-1.684h8.421a.842.842,0,1,1,0,1.684Zm0,3.368H18.316a.842.842,0,0,1,0-1.684h8.421a.842.842,0,1,1,0,1.684Z",
    transform: "translate(-0.632 -2.526)",
    fill: "#b07f4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 13.474,
    height: 6.737,
    rx: 1,
    transform: "translate(13.474 9.211)",
    fill: "none",
    stroke: "#b07f4a",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 6.579,
    height: 6.737,
    rx: 1,
    transform: "translate(30.474 11.737)",
    fill: "none",
    stroke: "#b07f4a",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 6.579,
    height: 6.737,
    rx: 1,
    transform: "translate(3.368 11.737)",
    fill: "none",
    stroke: "#b07f4a",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    d: "M37.895,7.526H31.158A2.526,2.526,0,0,0,28.632,5H11.789A2.526,2.526,0,0,0,9.263,7.526H2.526A2.526,2.526,0,0,0,0,10.053V31.947a2.526,2.526,0,0,0,2.526,2.526H9.263A2.526,2.526,0,0,0,11.789,37H28.632a2.526,2.526,0,0,0,2.526-2.526h6.737a2.526,2.526,0,0,0,2.526-2.526V10.053A2.526,2.526,0,0,0,37.895,7.526ZM2.526,32.789a.842.842,0,0,1-.842-.842V10.053a.842.842,0,0,1,.842-.842H9.263V21H7.579a.842.842,0,0,0,0,1.684H9.263v1.684H7.579a.842.842,0,0,0,0,1.684H9.263v1.684H7.579a.842.842,0,1,0,0,1.684H9.263v3.368Zm26.947,1.684a.842.842,0,0,1-.842.842H11.789a.842.842,0,0,1-.842-.842V7.526a.842.842,0,0,1,.842-.842H28.632a.842.842,0,0,1,.842.842Zm9.263-2.526a.842.842,0,0,1-.842.842H31.158V29.421h5.053a.842.842,0,1,0,0-1.684H31.158V26.053h5.053a.842.842,0,1,0,0-1.684H31.158V22.684h5.053a.842.842,0,1,0,0-1.684H31.158V9.211h6.737a.842.842,0,0,1,.842.842Z",
    transform: "translate(0)",
    fill: "#b07f4a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonation4);
export default __webpack_public_path__ + "static/media/donation4.715f5da9488adfd79b86238efc4433b2.svg";
export { ForwardRef as ReactComponent };